import { putRequest } from 'src/api/apiPut';
import { USER_FEEDBACK } from 'src/config';
import { UpdateUserFeedbackRequest, UserFeedbackResponse } from 'src/models/UserFeedback';
import { getData } from 'src/api/apiGet';

export function getUserFeedback(chatId: number, attribute: string): Promise<UserFeedbackResponse | void> {
  return getData(USER_FEEDBACK, {['chatId']: chatId, ['attribute']: attribute})
    .then(response => {
      if (response.status === 200) {
        return response.json();
      }
    })
    .then(data => {
      return data;
    })
    .catch((e) => {
      console.log('getUserFeedback error ', e)
    });
}

export const updateUserFeedback = (requestData: UpdateUserFeedbackRequest) => {
  return putRequest(USER_FEEDBACK, requestData).then(response => {
    return response.status == 200
  });
};
